import type Monaco from 'monaco-editor';

export const getMonacoEditorInputElement = (
  editor: Monaco.editor.IStandaloneCodeEditor | null
): HTMLInputElement | null => {
  // TODO(wbowers): Is there a better way to get the editor's input element?
  return editor?.getDomNode()?.querySelector('.inputarea') || null;
};

export const isMonacoEditorFocused = (editor: Monaco.editor.IStandaloneCodeEditor | null): boolean => {
  return getMonacoEditorInputElement(editor) === document.activeElement;
};

export const defineCustomTheme = (
  themeName: string,
  monaco: { editor: { defineTheme: typeof Monaco.editor.defineTheme } },
  isDarkMode: boolean
) => {
  monaco.editor.defineTheme(themeName, {
    base: isDarkMode ? 'vs-dark' : 'vs',
    inherit: true,
    rules: isDarkMode
      ? [{ token: 'string.sql', foreground: 'FF6B6B' }]
      : [
          // custom colors to fix contrast issues for SQL in light mode
          { token: 'string.sql', foreground: 'EB0000' },
          { token: 'operator.sql', foreground: '637483' },
          { token: 'predefined.sql', foreground: 'D100D1' },
        ],
    colors: {},
  });
};
